import { DeliveryServicesUI } from "./DeliveryServicesUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { VariantServices } from "../../types/types";

export function DeliveryServices({
  product,
  configProps,
}: Pick<StandardProps, "product" | "configProps">) {
  const { variant } = useVariant(product);
  const { services = [] } = variant;

  const deliveryServices = services.filter(({ __typename }) =>
    ["DeliveryService", "ExtendedWarranty"].includes(__typename),
  ) as VariantServices;

  const hasDeliveryServices = (deliveryServices ?? []).length > 0;

  const deliveryServiceQuestionnaireEnabled =
    (configProps?.deliveryServiceQuestionnaireEnabled as boolean) || false;

  if (!hasDeliveryServices) return null;

  return (
    <DeliveryServicesUI
      availableToOrder={variant?.availability?.availableToOrder || false}
      variantServices={deliveryServices}
      deliveryServiceQuestionnaireEnabled={deliveryServiceQuestionnaireEnabled}
    />
  );
}
